
import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";  // 確保路徑正確

import { useLocation } from 'react-router-dom';

const Carousel = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Carousel", "Carousel_lang"); // ✅
  }, [language]);
  const LANGUAGE = componentLanguageData.Carousel || { Main: {} };
  const location = useLocation();

  // 定義對應的標題和麵包屑
  const pageData = {
    '/': {
      title: LANGUAGE.Main.Content1,
      breadcrumbs: [{ label: LANGUAGE.Main.Content1, link: '/' }],
    },
    '/about': {
      title: LANGUAGE.Main.Content2,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content2, link: '/about' },
      ],
    },
    '/partners': {
      title: LANGUAGE.Main.Content3,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content3, link: '/partners' },
      ],
    },
    '/video': {
      title: LANGUAGE.Main.Content15,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content15, link: '/video' },
      ],
    },
    '/service': {
      title: LANGUAGE.Main.Content4,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content4, link: '/service' },
      ],
    },
    '/feature': {
      title: LANGUAGE.Main.Content5,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content5, link: '/feature' },
      ],
    },
    '/team': {
      title: LANGUAGE.Main.Content6,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content6, link: '/team' },
      ],
    },
    '/pricing': {
      title: LANGUAGE.Main.Content14,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content14, link: '/pricing' },
      ],
    },
    '/contact': {
      title: LANGUAGE.Main.Content7,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content7, link: '/contact' },
      ],
    },
    '/terms_api': {
      title: LANGUAGE.Main.Content9,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content9, link: '/terms_api' },
      ],
    },
    '/terms_payment': {
      title: LANGUAGE.Main.Content10,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content10, link: '/terms_payment' },
      ],
    },
    '/terms_disclaimer': {
      title: LANGUAGE.Main.Content11,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content11, link: '/terms_disclaimer' },
      ],
    },
    '/terms_platform': {
      title: LANGUAGE.Main.Content12,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content12, link: '/terms_platform' },
      ],
    },
    '/terms_privacy': {
      title: LANGUAGE.Main.Content13,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content13, link: '/terms_privacy' },
      ],
    },
    '/product_ai': {
      title: LANGUAGE.Main.Content16,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content16, link: '/product_ai#header-carousel' },
      ],
    },
    '/product_lib': {
      title: LANGUAGE.Main.Content17,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content17, link: '/product_lib' },
      ],
    },
    '/product_download': {
      title: LANGUAGE.Main.Content23,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content23, link: '/product_lib' },
      ],
    },
    '/outsourcing': {
      title: LANGUAGE.Main.Content18,
      breadcrumbs: [
        { label: LANGUAGE.Main.Content1, link: '/' },
        { label: LANGUAGE.Main.Content18, link: '/outsourcing' },
      ],
    },
    // 可根據需要繼續添加其他路徑
  };

  // 根據當前路徑獲取對應的數據
  const { title, breadcrumbs } = pageData[location.pathname] || {
    title: LANGUAGE.Main.Content7,
    breadcrumbs: [{ label: LANGUAGE.Main.Content1, link: '/' }],
  };

  return (
    <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: '90px' }}>
      <div className="row py-5">
        <div className="col-12 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-4 text-white animated zoomIn">{title}</h1>
          {location.pathname === '/product_ai' && (
            <div className="mt-2">
              <a href="#" className="h5 text-white">{LANGUAGE.Main.Content19}</a>
              <i className="far fa-circle text-white px-2"></i>
              <a href="#" className="h5 text-white">{LANGUAGE.Main.Content20}</a>
            </div>
          )}

          {location.pathname === '/product_lib' && (
            <div className="mt-2">
              <a href="#" className="h5 text-white">{LANGUAGE.Main.Content21}</a>
              <i className="far fa-circle text-white px-2"></i>
              <a href="#" className="h5 text-white">{LANGUAGE.Main.Content22}</a>
            </div>
          )}


          {/* <nav>
                {breadcrumbs.map((breadcrumb, index) => (
                  <React.Fragment key={index}>
                    <a
                      href={breadcrumb.link}
                      className="h5 text-white"
                      style={{ textDecoration: 'none' }}
                    >
                      {breadcrumb.label}
                    </a>
                    {index < breadcrumbs.length - 1 && (
                      <i className="far fa-circle text-white px-2"></i>
                    )}
                  </React.Fragment>
                ))}
              </nav> */}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
